import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs';

import {
    NewVersionConfirmationService,
} from '../../shared/components/new-version-confirmation-dialog/new-version-confirmation.service';

@Injectable()
export class PromptUpdateService {
    private newVersionConfirmationService = inject(NewVersionConfirmationService);
    public http = inject(HttpClient);
    public swUpdate = inject(SwUpdate);

    constructor() {
        this.swUpdate.versionUpdates
            .pipe(
                filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
            .subscribe((evt) => {
                this.http.get<{ version: string }>('/version.json').subscribe(data => {
                    this.newVersionConfirmationService.showDialog.next(true);
                    this.newVersionConfirmationService.version.next(data.version);
                });
            });

    }
}
